import { render, staticRenderFns } from "./order-refund-request-list.vue?vue&type=template&id=08973a11&scoped=true&"
import script from "./order-refund-request-list.vue?vue&type=script&lang=js&"
export * from "./order-refund-request-list.vue?vue&type=script&lang=js&"
import style0 from "./order-refund-request-list.vue?vue&type=style&index=0&id=08973a11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08973a11",
  null
  
)

export default component.exports